import {Component} from '@angular/core';

import {ValueView} from '../../value-view';

@Component({
  selector: 'ax-boolean-value-view',
  templateUrl: './boolean-value-view.component.html',
})
export class BooleanValueViewComponent extends ValueView {}
